var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFb12X12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.9333C2.16667 11.4333 0 8.96667 0 6C0 2.7 2.7 0 6 0C9.3 0 12 2.7 12 6C12 8.96667 9.83333 11.4333 7 11.9333L6.66667 11.6667H5.33333L5 11.9333Z",
    fill: "url(#paint0_linear_4048_13384)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 7.66666L8.6 6H7V4.83333C7 4.36666 7.16667 4 7.9 4H8.66667V2.46666C8.23333 2.39999 7.76667 2.33333 7.33333 2.33333C5.96667 2.33333 5 3.16666 5 4.66666V6H3.5V7.66666H5V11.9C5.33333 11.9667 5.66667 12 6 12C6.33333 12 6.66667 11.9667 7 11.9V7.66666H8.33333Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4048_13384",
    x1: 6,
    y1: 11.5847,
    x2: 6,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFb12X12);
export default __webpack_public_path__ + "static/media/ic_fb_12x12.af50e52286fc6db4a0c319761cd0d9ae.svg";
export { ForwardRef as ReactComponent };